import { CreditCard, FinancialObligation, PersonalLoan, PrivateLease } from '@ap/ap-interface-apix-hypotheken-berekening';
import { Money } from '@ap/interface-bspc-core';

export class FinancialObligationsBuilder {
    private studentDebt?: Money;
    private paymentAccountOverdraft?: Money;
    private mobilePhonePayment?: Money;
    private openEndedCredit?: Money;
    private creditCard?: CreditCard;
    private privateLease?: PrivateLease;
    private personalLoan?: PersonalLoan;
    private partnerAlimony?: Money;

    withStudentDebt(studentDebt: Money): this {
        this.studentDebt = studentDebt;
        return this;
    }

    withPaymentAccountOverdraft(paymentAccountOverdraft: Money): this {
        this.paymentAccountOverdraft = paymentAccountOverdraft;
        return this;
    }

    withMobilePhonePayment(mobilePhonePayment: Money): this {
        this.mobilePhonePayment = mobilePhonePayment;
        return this;
    }

    withOpenEndedCredit(openEndedCredit: Money): this {
        this.openEndedCredit = openEndedCredit;
        return this;
    }

    withCreditCard(creditCard: CreditCard): this {
        this.creditCard = creditCard;
        return this;
    }

    withPrivateLease(privateLease: PrivateLease): this {
        this.privateLease = privateLease;
        return this;
    }

    withPersonalLoan(personalLoan: PersonalLoan): this {
        this.personalLoan = personalLoan;
        return this;
    }

    withPartnerAlimony(partnerAlimony: Money): this {
        this.partnerAlimony = partnerAlimony;
        return this;
    }

    build(): FinancialObligation {
        return {
            student_debt_amount: this.studentDebt,
            payment_account_overdraft_amount: this.paymentAccountOverdraft,
            mobile_phone_payment_amount: this.mobilePhonePayment,
            open_ended_credit_amount: this.openEndedCredit,
            credit_card: this.creditCard,
            private_lease: this.privateLease,
            personal_loan: this.personalLoan,
            partner_alimony_amount: this.partnerAlimony
        } as FinancialObligation;
    }
}
